import { BaseQueryFn, FetchArgs, FetchBaseQueryError, createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { store, RootState } from "../store";
import { EnvironmentConfig } from "../../utils/config/environment.config";

const baseQuery = fetchBaseQuery({
  baseUrl: `${EnvironmentConfig.backendUrl}/api`,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    headers.set("Access-Control-Allow-Origin", EnvironmentConfig.frontendUrl);
    headers.set(
      "Access-Control-Allow-Header",
      "POST, GET, PUT, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method"
    );
    return headers;
  },
});

const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    localStorage.clear();
    const state: RootState = store.getState();
    state.auth = {
      events: null,
      menu: null,
      token: null,
      user: null,
      roles: null,
    };
    window.location.reload();
  }
  return result;
};

export const reduxApiService = createApi({
  reducerPath: "spider-api",
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
});
